import React, { useEffect, useState } from "react";
import BodyWrapper from "../utils/BodyWrapper";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { API } from "../App";

function CategoryPosts() {
  const { id, permalink } = useParams();
  const [category, setCategory] = useState({});
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();
  const fetchCategory = async () => {
    try {
      const response = await fetch(`${API}/public/category/${id}`)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            switch (res.status) {
              case 401:
                throw new Error(
                  "You are not authorized to perform this action"
                );
              case 404:
                throw new Error("The resource you requested was not found");
              default:
                console.log(res.status);
            }
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
      if (response) {
        setCategory(response);
        fetchCategoryPosts(response);
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  const fetchCategoryPosts = async (category) => {
    try {
      const response = await fetch(
        `${API}/categorias/${category.title}/${category.id}`
      )
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            switch (res.status) {
              case 401:
                throw new Error(
                  "You are not authorized to perform this action"
                );
              case 404:
                throw new Error("The resource you requested was not found");
              default:
                console.log(res.status);
            }
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
      if (response) {
        setPosts(response);
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    fetchCategory();
  }, []);
  return (
    <>
      <BodyWrapper>
        <button
          onClick={() => window.history.back()}
          className="categoryposts__backBtn"
        >
          <ArrowBackIosNewIcon />
        </button>
        <div className="categoryposts">
          <h1 className="categoryposts__title">{category.title}</h1>
          <article className="categoryposts__posts">
            {posts.map((i) => {
              return (
                <div key={i.id} className="categoryposts__post">
                  {i.contents[0]?.path ? (
                    <img
                      src={`/content/${i.contents[0]?.path}`}
                      alt="postCard"
                    />
                  ) : (
                    <img src="/no-image.jfif" alt="postCard" />
                  )}
                  <div className="categoryposts__postContent">
                    <span className="categoryposts__postTitle">{i.title}</span>
                    <span className="categoryposts__postDescription">
                      {i.description}
                    </span>
                    <button
                      onClick={() => {
                        let transformedTitle = i.title
                          ?.replaceAll("/", "-")
                          .split(" ")
                          .join("-")
                          .toLowerCase();
                        let path = `/publicaciones/${transformedTitle}/${i.id}`;
                        navigate(path);
                      }}
                      className="categoryposts__viewMoreBtn"
                    >
                      Leer más {">>"}
                    </button>
                  </div>
                </div>
              );
            })}
          </article>
        </div>
      </BodyWrapper>
    </>
  );
}

export default CategoryPosts;
